/**
 * Formats milliseconds remaining as "M:SS" (e.g. 245000 -> "4:05").
 * Shared by the checkout tab's payment timer and the opening tab's "checkout
 * is open in another tab" card, so both show the same clock. Ported from the
 * court-booking system.
 * @param {number} ms - milliseconds remaining, may be negative.
 * @returns {string} clamped, zero-padded countdown label.
 */
export const formatCountdown = (ms) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

/**
 * Milliseconds until a deadline, or null when there is no deadline.
 * @param {number|null|undefined} deadlineMs - epoch milliseconds
 * @returns {number|null}
 */
export const msUntil = (deadlineMs) => (deadlineMs ? Number(deadlineMs) - Date.now() : null);
